import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const getRouteLength = () => {
  return window
    .getPathname()
    .split(`/${SpringConfigs.CASINO_MOUNT_PATH}/`)?.[1]
    ?.split('/').length;
};
